const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-video');
const Show = resolve => require.ensure([], () => resolve(require('./Show.vue')), 'group-video');

export default [{
  path: '/videos',
  name: 'videos',
  component: Index,
  meta: {
    title: '资源列表',
    layout: 'compete',
  },
}, {
  path: '/videos/:id',
  name: 'videos/:id',
  component: Show,
  meta: {
    title: '详情',
    layout: 'compete',
  },
}];




// WEBPACK FOOTER //
// ./src/components/User/resources/videos/index.js